// extracted by mini-css-extract-plugin
module.exports = {"titleAccordion":"Accordion_titleAccordion__33jVZ","mobileMenu":"Accordion_mobileMenu__1i8aF"};